import {HttpModelConverter} from '../../core/converter/httpModel.converter';
import {PermissionsModel} from '../entity/permissions.model';
import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class PermissionsConverter extends HttpModelConverter<PermissionsModel> {

    protected enrichObject(result: PermissionsModel, src: PermissionsModel) {
    }

    protected createInstance(): PermissionsModel {
        return new PermissionsModel();
    }
}
